import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/lib/content";

const NAV = [
  { label: "Services", id: "services" },
  { label: "Why Us", id: "why" },
  { label: "Process", id: "process" },
  { label: "Industries", id: "industries" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer
      data-testid="footer"
      className="grain relative overflow-hidden pt-20 pb-10"
      style={{ background: "#082a5f" }}
    >
      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid gap-12 border-b border-white/10 pb-14 lg:grid-cols-[1.4fr_1fr_1.2fr]">
          <div>
            <div className="flex items-center gap-3">
              <span
                className="flex h-12 w-12 items-center justify-center overflow-hidden bg-white"
              >
                <img
                  src={CONTACT.logo}
                  alt="Sanwariya Elevator Logo"
                  className="h-full w-full object-contain p-1"
                />
              </span>
              <span className="font-display text-2xl font-bold tracking-tight text-white">
                Sanwariya Elevator
              </span>
            </div>
            <p className="mt-5 max-w-sm font-body text-sm leading-relaxed text-white/60">
              Safe • Reliable • Professional Elevator Solutions. Installation,
              Repair, AMC & Modernization across Jaipur, Rajasthan.
            </p>
          </div>

          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.25em] text-[#D89A18]">
              Explore
            </h4>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button
                    data-testid={`footer-nav-${n.id}`}
                    onClick={() => go(n.id)}
                    className="font-body text-sm text-white/70 transition-colors hover:text-[#D89A18]"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-body text-xs uppercase tracking-[0.25em] text-[#D89A18]">
              Contact
            </h4>
            <ul className="mt-5 space-y-4 font-body text-sm text-white/70">
              <li>
                <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 hover:text-[#D89A18]">
                  <Phone size={16} className="text-[#D89A18]" /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT.tollFreeRaw}`} className="flex items-center gap-3 hover:text-[#D89A18]">
                  <Phone size={16} className="text-[#D89A18]" />
                  <span>
                    <span className="mr-1 text-[10px] uppercase tracking-[0.2em] text-[#D89A18]">Toll Free</span>
                    {CONTACT.tollFree}
                  </span>
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-[#D89A18]">
                  <Mail size={16} className="text-[#D89A18]" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 flex-shrink-0 text-[#D89A18]" />
                <span>{CONTACT.address.join(", ")}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col items-center justify-between gap-3 pt-8 md:flex-row">
          <p className="font-body text-xs text-white/50">
            © 2026 Sanwariya Elevator. All Rights Reserved.
          </p>
          <p className="font-body text-xs uppercase tracking-[0.2em] text-white/40">
            Jaipur · Rajasthan · India
          </p>
        </div>
      </div>
    </footer>
  );
}
